// extracted by mini-css-extract-plugin
export default {"ListContainer":"ReleaseItemList_ListContainer__i-4GQ"};